import {
  FLUSH_SOCIAL_ACT_STATE,
  SELECT_CONTACT,
} from 'actiontypes/socialAct';

import {
  ADD_NEW_CONTACT_SUCCESS,
  CHOOSE_BRANCH_SUCCESS,
  FETCH_INELIGIBLE_CONTACTS_SUCCESS,
  SEND_SOCIAL_INVITATION_FAILURE,
  SEND_SOCIAL_INVITATION_REQUESTED,
  SEND_SOCIAL_INVITATION_SUCCESS,
} from 'actiontypes/storylet';

const INITIAL_STATE = {
  eligibleFriends: [],
  ineligibleFriends: [],
  isSending: false,
  selectedContactId: undefined,
};

export default function reducer(state = INITIAL_STATE, action) {
  const { payload, type } = action;

  switch (type) {
    case ADD_NEW_CONTACT_SUCCESS:
      return {
        ...state,
        eligibleFriends: payload.eligibleFriends,
      };

    case CHOOSE_BRANCH_SUCCESS:
      return {
        ...state,
        ...payload.socialAct,
        eligibleFriends: payload.eligibleFriends,
      };

    case FETCH_INELIGIBLE_CONTACTS_SUCCESS:
      return {
        ...state,
        ineligibleContacts: payload.ineligibleContacts,
      };

    case SELECT_CONTACT:
      return {
        ...state,
        selectedContactId: payload,
      };

    case SEND_SOCIAL_INVITATION_FAILURE:
      return { ...state, isSending: false };

    case SEND_SOCIAL_INVITATION_REQUESTED:
      return { ...state, isSending: true };

    case SEND_SOCIAL_INVITATION_SUCCESS:
      return { ...state, isSending: false };

    case FLUSH_SOCIAL_ACT_STATE:
      // We are going through or backing out of a social act,
      // so we don't want to preserve any of this state
      return INITIAL_STATE;

    default:
      return state;
  }
}